import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from '@mui/material/styles';

const isVertical = (side) => side === 'right' || side === 'left';
const handleClass = 'handle';
const Wrapper = styled('div', { shouldForwardProp: prop => !['side', 'handleAxis'].includes(prop) })(({ side }) => {
    const baseSize = 20;
    return Object.assign(Object.assign({}, (isVertical(side)
        ? Object.assign({ width: `${baseSize}px`, height: '100%', cursor: 'ew-resize' }, (side === 'right' ? { right: -(baseSize / 2) } : { left: -(baseSize / 2) })) : Object.assign({ height: `${baseSize}px`, width: '100%', cursor: 'ns-resize' }, (side === 'top' ? { top: -(baseSize / 2) } : { bottom: -(baseSize / 2) })))), { [`&:hover .${handleClass}`]: { display: 'flex' }, padding: '0 0 0 0 !important', position: 'absolute', display: 'flex', justifyContent: 'center', alignItems: 'center' });
});
const Handle = styled('div', { shouldForwardProp: prop => !['side'].includes(prop) })(({ theme, side }) => (Object.assign(Object.assign({}, (isVertical(side) ? { width: '2px', height: '100%' } : { height: '2px', width: '100%' })), { backgroundColor: theme.palette.primary.main, display: 'none', zIndex: 10 })));
const ResizableHandle = React__default.forwardRef(function ResizableHandle(props, ref) {
    const { side } = props, restProps = __rest(props, ["side"]);
    return (jsx(Wrapper, Object.assign({ side: side, ref: ref, "data-testid": "resizeable-handle-wrapper" }, restProps, { children: jsx(Handle, { side: side, className: handleClass, "data-testid": "resizeable-handle" }) })));
});

export { ResizableHandle as default };
//# sourceMappingURL=ResizableHandle.js.map
